import find from 'lodash/find'

/** Returns the entry whose value matches, or undefined when no entry matches. */
export const findStatus = <T extends { value: string }>(statuses: Record<string, T>, value?: string): T | undefined =>
  find(statuses, (e) => e.value === value)
